import { render, staticRenderFns } from "./NewReminder.vue?vue&type=template&id=7d8d0e70&scoped=true&"
import script from "./NewReminder.vue?vue&type=script&lang=js&"
export * from "./NewReminder.vue?vue&type=script&lang=js&"
import style0 from "./NewReminder.vue?vue&type=style&index=0&id=7d8d0e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8d0e70",
  null
  
)

export default component.exports